import { render, staticRenderFns } from "./ReferencesList.vue?vue&type=template&id=2c90f6d2&scoped=true&"
import script from "./ReferencesList.vue?vue&type=script&lang=js&"
export * from "./ReferencesList.vue?vue&type=script&lang=js&"
import style0 from "./ReferencesList.vue?vue&type=style&index=0&id=2c90f6d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c90f6d2",
  null
  
)

export default component.exports